import { createSlice } from '@reduxjs/toolkit';

export const forwardSlice = createSlice({
  name: 'forward',
  initialState: {
    isActive: false,
    url: '',
    currentType: 0,
    currentId: 0,
  },
  reducers: {
    forwardUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    forwardUpdateUrl: (state, action) => {
      state.url = action.payload;
    },
    forwardUpdateCurrentType: (state, action) => {
      state.currentType = action.payload;
    },
    forwardUpdateCurrentId: (state, action) => {
      state.currentId = action.payload;
    },
  },
});

export const { forwardUpdateIsActive, forwardUpdateUrl, forwardUpdateCurrentType, forwardUpdateCurrentId } = forwardSlice.actions;

export const selectForwardIsActive = (state) => state.forward.isActive;
export const selectForwardUrl = (state) => state.forward.url;
export const selectForwardCurrentType = (state) => state.forward.currentType;
export const selectForwardCurrentId = (state) => state.forward.currentId;

export default forwardSlice.reducer;
